// extracted by mini-css-extract-plugin
export var lg = "_k1-7";
export var md = "_k1-6";
export var placeholderContainer = "_k1-1";
export var placeholderIcon = "_k1-2";
export var productImage = "_k1-0";
export var sm = "_k1-5";
export var xl = "_k1-8";
export var xs = "_k1-4";
export var xxs = "_k1-3";